import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import {
  kubernetesAuthProvidersApiRef,
  KubernetesAuthProviders,
} from '@backstage/plugin-kubernetes-react';
import {
  gitlabAuthApiRef,
  googleAuthApiRef,
  microsoftAuthApiRef,
  oktaAuthApiRef,
  oneloginAuthApiRef,
} from '@backstage/core-plugin-api';
import { oidcAuthApiRef } from '../auth';

// Override the kubernetes plugin's built-in auth-providers API factory
// (extension id `api:kubernetes/auth-providers`) to ADD our Keycloak provider
// under the OIDC slot key `aknostic`. This reuses the generic oidc.<key>
// mechanism (the pattern Backstage's OpenShift integration ships) instead of
// providing the apiRef from a foreign plugin — the latter caused
// API_FACTORY_CONFLICT. Clusters select it with:
//   kubernetes.io/auth-provider: oidc
//   kubernetes.io/oidc-token-provider: aknostic
//
// The override uses the `factory` middleware form (the only shape the typings
// accept — `.override` has no top-level `params` key). We ignore the original
// factory's output entirely and re-emit the API extension via the original
// factory with our own params: same five built-in OIDC providers plus
// `aknostic`. In the override overload, `originalFactory` takes a single
// context object `{ params }` (not positional params like makeWithOverrides),
// and returns the extension's data container — the iterable the override must
// yield. ApiBlueprint uses advanced params, so params is a
// `defineParams => defineParams(<factory spec>)` callback.
export const kubernetesWithOidc = kubernetesPlugin.withOverrides({
  extensions: [
    kubernetesPlugin.getExtension('api:kubernetes/auth-providers').override({
      factory: originalFactory =>
        originalFactory({
          params: defineParams =>
            defineParams({
              api: kubernetesAuthProvidersApiRef,
              deps: {
                gitlabAuthApi: gitlabAuthApiRef,
                googleAuthApi: googleAuthApiRef,
                microsoftAuthApi: microsoftAuthApiRef,
                oktaAuthApi: oktaAuthApiRef,
                oneloginAuthApi: oneloginAuthApiRef,
                aknosticAuthApi: oidcAuthApiRef,
              },
              factory: ({
                gitlabAuthApi,
                googleAuthApi,
                microsoftAuthApi,
                oktaAuthApi,
                oneloginAuthApi,
                aknosticAuthApi,
              }) =>
                new KubernetesAuthProviders({
                  microsoftAuthApi,
                  googleAuthApi,
                  oidcProviders: {
                    gitlab: gitlabAuthApi,
                    google: googleAuthApi,
                    microsoft: microsoftAuthApi,
                    okta: oktaAuthApi,
                    onelogin: oneloginAuthApi,
                    aknostic: aknosticAuthApi,
                  },
                }),
            }),
        }),
    }),
  ],
});
